import axios from 'axios'
import {API_ADMIN} from '@/utils/constants/Api'
import { OrderModel } from '@/order/models/OrderModel'
import { OrderTrackingCodeModel } from '@/order/models/OrderTrackingCodeModel'
import {IFilterList} from '@/utils/interfaces/FilterListInterface'
import { OrderFakeModel } from '../models/OrderFakeModel'
import { OrderInvoiceModel } from '../models/OrderInvoiceModel'
import { OrderXmlModel } from '../models/OrderXmlModel'

export default {
    getOrders(page:number, filterList:IFilterList):Promise<OrderModel[]> {
        return axios.get(`${API_ADMIN}orders?page=${page}${filterList.toPartialQueryString()}`)
            .then(({data}) => {
                return data.map((o:OrderModel) => new OrderModel(o));
            });
    },
    getOrderById(id:number):Promise<OrderModel> {
        return axios.get(`${API_ADMIN}orders/${id}`)
            .then(({data}) => {
                return new OrderModel(data);
            });
    },
    updateTrackingCode(id:number, trackingCode: OrderTrackingCodeModel):Promise<undefined> {
        return axios.patch(`${API_ADMIN}orders/${id}/tracking_code`, trackingCode);
    },
    addXml(orderId:number, orderXml: OrderXmlModel):Promise<any> {
        return axios.post(`${API_ADMIN}orders/${orderId}/invoices/${orderXml.invoiceId}/add_xml`, orderXml)
            .then(({data}) => {
                return data;
            });
    },
    forceChannelSync(id:number):Promise<void> {
        return axios.post(`${API_ADMIN}orders/${id}/force_channel_sync`)
            .then(({data}) => {
                // {message: string}
                return data
            })
    },
    retrySync(id:number):Promise<any> {
        return axios.post(`${API_ADMIN}orders/${id}/retry_sync`)
            .then(({data}) => {
                // {message:string}
                return data;
            });
    },
    setStatusToApproved(id: number):Promise<OrderModel> {
        return axios.patch(`${API_ADMIN}orders/${id}/approved`)
            .then(({data}) => {
                return new OrderModel(data);
            });
    },
    setStatusToPosted(id: number):Promise<OrderModel> {
        return axios.patch(`${API_ADMIN}orders/${id}/posted`)
            .then(({data}) => {
                return new OrderModel(data);
            });
    },
    setStatusToDelivered(id: number):Promise<OrderModel> {
        return axios.patch(`${API_ADMIN}orders/${id}/delivered`)
            .then(({data}) => {
                return new OrderModel(data);
            });
    },
    setStatusToCanceled(id: number):Promise<OrderModel> {
        return axios.patch(`${API_ADMIN}orders/${id}/canceled`)
            .then(({data}) => {
                return new OrderModel(data);
            });
    },
    createFakeOrder(of: OrderFakeModel):Promise<OrderModel> {
        return axios.post(`${API_ADMIN}developer/orders/create_example`, of)
            .then(({data}) => {
                return new OrderModel(data);
            })
    },
    getOrderInvoiceXml(invoice: OrderInvoiceModel):Promise<any> {
        return axios.get(`${API_ADMIN}orders/invoices/${invoice.id}/xml`)
            .then(({data}) => {
                return data;
            })
    },
    deleteOrder(id: number): Promise<void> {
        return axios.delete(`${API_ADMIN}orders/${id}`)
    },
    reimport(id:number):Promise<any> {
        return axios.post(`${API_ADMIN}orders/${id}/reimport`)
            .then(({data}) => {
                return data;
            });
    },
    importSpecific(idChannel:number, idExternalChannel: number):Promise<any> {
        return axios.post(`${API_ADMIN}orders/sync_specific`, {idChannel, idExternalChannel})
            .then(({data}) => {
                return data;
            });
    },
}
